module.exports = __webpack_public_path__ + "img/48.68ed076d.jpg";